import VChip from './VChip'

export { VChip }
export default VChip



// WEBPACK FOOTER //
// ../../../src/components/VChip/index.ts